import React from "react";
import Styles from "../Home/AboutMe.module.css";

const Github = () => {
  return (
    <div className={Styles.Main}>
      Hey, I'm Hrusikesh! Welcome to my github page. 🌱 I'm a software developer
      who creates open-source projects and writes about code, design, and life.
      I like accordions, outer space, board games, and stand-up comedy. Check
      out my projects and articles I've written on subjects like game design,
      security, front end development, or learn more about me.
    </div>
  );
};

export default Github;
